import { useUserEventLogger } from '@repo/tracking-service';
import { Fieldset, TextField, Title } from '@zenterprise-inc/ui';
import { ChangeEvent, FormEventHandler } from 'react';

import { useChangePasswordContext } from '@/components/my/password/contexts/ChangePasswordProvider';
import { CurrentPasswordCta } from '@/components/my/password/current-password/CurrentPasswordCta';
import { ForgotPasswordButton } from '@/components/my/password/current-password/ForgotPasswordButton';
import { usePasswordError } from '@/components/my/password/hooks/use-password-error';

export const CurrentPasswordForm = () => {
  const { password, changePassword, checkPassword, renderNextPage } = useChangePasswordContext();
  const { inputPasswordError, invalidPasswordError, passwordError, resetPasswordError, unknownErrorToast } = usePasswordError();
  const { sendClickEvent } = useUserEventLogger();

  const isError = passwordError !== 'NONE';

  const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
    // checkPassword 로 에러가 생긴 경우 에러 초기화
    if (passwordError !== 'NONE') {
      resetPasswordError();
    }
    changePassword(e);
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    sendClickEvent('pw-check_bottom_complete');

    checkPassword({
      onCompleted: () => {
        renderNextPage();
      },
      onInvalid: () => {
        invalidPasswordError();
      },
      onError: () => {
        unknownErrorToast();
      }
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <section className={'px-4.5'}>
        <Title.Headline title={'본인 확인을 위해\n현재 비밀번호를 입력해주세요'} size={'large'} />

        <Fieldset.Wrapper isInvalid={isError}>
          <Fieldset.Label>비밀번호</Fieldset.Label>
          <TextField.Password
            className={'flex'}
            value={password}
            autoComplete={'off'}
            onChange={handleChangePassword}
            onBlur={() => inputPasswordError(password)}
            error={isError}
          />
          {passwordError === 'EMPTY' && <Fieldset.Error>비밀번호를 입력해주세요.</Fieldset.Error>}
          {passwordError === 'MIN_LENGTH' && <Fieldset.Error>6자 이상 입력해주세요.</Fieldset.Error>}
          {passwordError === 'INVALID' && <Fieldset.Error>비밀번호가 일치하지 않아요. 다시 입력해주세요.</Fieldset.Error>}
        </Fieldset.Wrapper>

        <ForgotPasswordButton />
      </section>

      <CurrentPasswordCta />
    </form>
  );
};
